"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

var validPunycode = /(?:xn--[\-0-9a-z]+)/;
exports.default = validPunycode;
module.exports = exports["default"];